/**
 * @generated SignedSource<<2a798b038ce24424d1a2e671bd35db39>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContemporaryLandingFeaturedModule_contemporaryLandingRow$data = {
  readonly items: ReadonlyArray<{
    readonly items?: ReadonlyArray<{
      readonly cta?: string | null;
      readonly description?: string | null;
      readonly imagePath?: string | null;
      readonly linkData?: {
        readonly " $fragmentSpreads": FragmentRefs<"SeoButton_linkData" | "SeoLink_linkData">;
      };
      readonly title?: string | null;
    } | null> | null;
    readonly text?: string | null;
    readonly type?: string | null;
  } | null> | null;
  readonly " $fragmentType": "ContemporaryLandingFeaturedModule_contemporaryLandingRow";
};
export type ContemporaryLandingFeaturedModule_contemporaryLandingRow$key = {
  readonly " $data"?: ContemporaryLandingFeaturedModule_contemporaryLandingRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContemporaryLandingFeaturedModule_contemporaryLandingRow">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContemporaryLandingFeaturedModule_contemporaryLandingRow",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            (v0/*:: as any*/)
          ],
          "type": "ContemporaryLandingHeader",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cta",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "imagePath",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LinkData",
                      "kind": "LinkedField",
                      "name": "linkData",
                      "plural": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "SeoButton_linkData"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "SeoLink_linkData"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "ContemporaryLandingFeaturedRowItem",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            (v0/*:: as any*/)
          ],
          "type": "ContemporaryLandingRow",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContemporaryLandingRow",
  "abstractKey": null
};
})();

(node as any).hash = "8f20cd0bd151b4d8323cf0e5d319cd5f";

export default node;
